// Что именно и кому уходит при AI-операциях — ОДИН текст на приложение.
//
// Показывают его две поверхности: экран разрешения при первом запуске
// приложения и «Приватность» в настройках. Разъехавшись, они дали бы ровно то,
// за что App Store заворачивал сборку по 5.1.1(i): человек разрешает одно, а в
// другом месте ему описано другое.
//
// Состав совпадает с дисклеймером об ИИ 1.1.0 (миграция 0151, разделы 2–4) —
// это краткое изложение того же документа, а не новая редакция. Меняется
// состав получателей — меняется и документ, и этот список.

import { IconArrowUpRight, IconBan, IconSend, IconServer } from "@tabler/icons-react";
import { Link } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

const SENT_KEYS = ["requests", "materials", "files", "voice"] as const;
const RECIPIENT_KEYS = ["google", "exa"] as const;
const NOT_SENT_KEYS = ["profile", "payments", "training"] as const;

function DisclosureList({
	icon,
	title,
	items,
}: {
	icon: React.ReactNode;
	title: string;
	items: readonly string[];
}): React.ReactElement {
	return (
		<section className="px-4 py-3.5">
			<h2 className="flex items-center gap-2 text-sm font-semibold text-foreground">
				<span className="shrink-0 text-muted-foreground">{icon}</span>
				{title}
			</h2>
			<ul className="mt-2 space-y-1.5 pl-6 text-sm leading-relaxed text-muted-foreground">
				{items.map((item) => (
					<li key={item} className="list-disc break-words marker:text-muted-foreground/60">
						{item}
					</li>
				))}
			</ul>
		</section>
	);
}

export function AiDataSharingDisclosure(): React.ReactElement {
	const { t } = useTranslation("legal");

	return (
		<div className="divide-y divide-border overflow-hidden rounded-[var(--radius-card)] border border-border bg-card shadow-e1">
			<DisclosureList
				icon={<IconSend size={16} stroke={1.75} />}
				title={t("aiDataSharing.sent.title")}
				items={SENT_KEYS.map((key) => t(`aiDataSharing.sent.items.${key}`))}
			/>
			<DisclosureList
				icon={<IconServer size={16} stroke={1.75} />}
				title={t("aiDataSharing.recipients.title")}
				items={RECIPIENT_KEYS.map((key) => t(`aiDataSharing.recipients.items.${key}`))}
			/>
			<DisclosureList
				icon={<IconBan size={16} stroke={1.75} />}
				title={t("aiDataSharing.notSent.title")}
				items={NOT_SENT_KEYS.map((key) => t(`aiDataSharing.notSent.items.${key}`))}
			/>
			<div className="px-4 py-3">
				<Link
					to="/legal/$kind"
					params={{ kind: "ai-disclaimer" }}
					className="inline-flex min-h-11 cursor-pointer items-center gap-1 text-sm text-primary lg:min-h-0"
				>
					{t("aiDataSharing.readDisclaimer")}
					<IconArrowUpRight size={14} stroke={1.75} />
				</Link>
			</div>
		</div>
	);
}
